import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import sharedStyles from './styles';

const Container = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  border: 1px solid ${({ theme }) => theme.colors.inputBorder};
  padding: ${sharedStyles.spacing['spacing-lg']};
  background: ${({ theme }) => theme.colors.cardBackground};
`;

const Quote = styled.q`
  &::before {
    content: '\\201C';
    display: block;
    color: ${({ theme }) => theme.colors.brandPrimary};
    font-size: ${sharedStyles.fontSize['6xl']};
    font-weight: ${sharedStyles.fontWeight.bold};
    height: ${sharedStyles.spacing['spacing-2xl']};
  }

  flex-grow: 1;
  font-weight: ${sharedStyles.fontWeight.bold};
`;

const Attribution = styled.div`
  text-align: right;
  margin-top: ${sharedStyles.spacing['spacing-lg']};
`;

const Author = styled.p`
  &:before {
    content: '\\2014 \\2003';
  }

  margin: 0;
`;

const Location = styled.p`
  margin: 0;
`;

function Testimonial({ quote, author, location = '' }) {
  return (
    <Container>
      <Quote>{quote}</Quote>

      <Attribution>
        <Author>{author}</Author>
        {location && <Location>{location}</Location>}
      </Attribution>
    </Container>
  );
}

Testimonial.propTypes = {
  quote: PropTypes.string.isRequired,
  author: PropTypes.string.isRequired,
  location: PropTypes.string,
};

export default Testimonial;
